import { render, staticRenderFns } from "./ReportBoxDetails.vue?vue&type=template&id=7e197b24&"
import script from "./ReportBoxDetails.vue?vue&type=script&lang=js&"
export * from "./ReportBoxDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e197b24')) {
      api.createRecord('7e197b24', component.options)
    } else {
      api.reload('7e197b24', component.options)
    }
    module.hot.accept("./ReportBoxDetails.vue?vue&type=template&id=7e197b24&", function () {
      api.rerender('7e197b24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity-flash/reports/ReportBoxDetails.vue"
export default component.exports